import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ClassificationEmployeur } from '../core/model/classification-employeur';
import { ClassificationEmployeurService } from '../core/service/classification-employeur.service';
import { AddClassificationEmployeurComponent } from './add-classification-employeur/add-classification-employeur.component';
import { EditClassificationEmployeurComponent } from './edit-classification-employeur/edit-classification-employeur.component';

@Component({
  selector: 'app-classification-employeur',
  templateUrl: './classification-employeur.component.html',
  styleUrls: ['./classification-employeur.component.scss']
})
export class ClassificationEmployeurComponent implements OnInit {

  classificationEmployeurs: ClassificationEmployeur[];

  constructor(
    private _classificationEmployeurService: ClassificationEmployeurService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._classificationEmployeurService.getAll().subscribe(
      (data) => {
        this.classificationEmployeurs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  add(): void {
    const modalRef = this.modalService.open(AddClassificationEmployeurComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getAll();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  
  edit(classificationEmployeur: ClassificationEmployeur): void {
    const modalRef = this.modalService.open(EditClassificationEmployeurComponent, {
      centered: true,
    });
    modalRef.componentInstance.classificationEmployeur = classificationEmployeur;

    modalRef.result.then(
      (updated: ClassificationEmployeur) => {
        if (updated && this.classificationEmployeurs) {
          const index = this.classificationEmployeurs.findIndex(
            (c) => c.id === updated.id
          );
          if (index !== -1) {
            this.classificationEmployeurs[index] = updated;
            this.classificationEmployeurs = [...this.classificationEmployeurs];
            return;
          }
        }
        this.getAll();
      },
      (reason) => {
        // on dismiss
      }
    );
  }


}
